import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import customerReducer from './customerReducer.js';

import { thunk } from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  customer: customerReducer,
});

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
